<template>
    <section class="info-box">
        <div class="title">{{info.title}}</div>
        <div class="meta">{{$date(info.addtime)}} · {{$view(info.views)}} 阅读</div>
        <article v-html="info.content" class="article"></article>
    </section>
</template>

<script>
    export default {
        data: () => ({
            info: {
                addtime: '',
                content: '',
                thumb: '',
                title: '',
                views: '',
            },
        }),
        computed: {
            id() {
                return +this.$route.params.id || 0;
            },
        },
        beforeMount() {
            this.api.get(`info/${this.id}`).then(e => {
                this.info = e;
                this.$share(e.title, e.thumb);
            }, this.err);
        }
    }
</script>

<style scoped>
    @import '../../../static/css/info/detail.css';
</style>


// WEBPACK FOOTER //
// src/components/info/Detail.vue